import { render } from "./AdsPerformancePage.vue?vue&type=template&id=44193b36"
import script from "./AdsPerformancePage.vue?vue&type=script&lang=js"
export * from "./AdsPerformancePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__